module.exports = __webpack_public_path__ + "static/media/eat.a976e4bd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/eat.svg
// module id = 170
// module chunks = 0